import { useFormik } from "formik";
import React, { useState } from "react";
import { InputField } from "components";
import { Col, Row } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";
import FinanceService from "Lib/API/Finance";
import AutoCompleteField from "components/autoCompleteField";
import MyButton from "components/MyButton";
import { addSubCategorySchema } from "pages/ValidationSchema";
import "../index.scss";
import { toastr } from "react-redux-toastr";

export const AddSubcategory = ({
  id,
  data,
  editClicked,
  refresh,
  setOpenModal,
  setRefresh,
  defaultValue,
  title,
}) => {
  const { getAccessTokenSilently } = useAuth0();
  const { ledgerAccounts } = useSelector((state) => state?.data);
  const [value, setValue] = useState({
    value: id,
    label: title,
  });
  const initialValues = {
    sub_cat_name: data?.sub_cat_name,
    year: data?.year,
    led_account: id === "sub-category" ? "" : id,
  };
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: addSubCategorySchema,
    onSubmit: async (values) => {
      const token = await getAccessTokenSilently();
      const input = {
        subCategory_id: data?._id,
        year: values.year,
        sub_cat_name: values.sub_cat_name,
      };
      const add = {
        led_account: value?.value,
        year: values.year,
        sub_cat_name: values.sub_cat_name,
      };
      if (editClicked)
        FinanceService.updateSubcategorie(input, token)
          .then((res) => {
            if (res) {
              setOpenModal(false);
              setRefresh(!refresh);
            }
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
      else
        await FinanceService.addSubcategorie(add, token)
          .then((res) => {
            if (res) {
              setOpenModal(false);
              setRefresh(!refresh);
            }
          })
          .catch((err) => {
            toastr.error("Error", err?.data?.message);
          });
    },
  });

  return (
    <dv className="add-ledger">
      <div className="form-title">
        {editClicked ? "Edit" : "Add"} sub-category
      </div>
      <div className="add-ledger-form">
        <form
          onSubmit={formik.handleSubmit}
          className="form fv-plugins-bootstrap fv-plugins-framework"
        >
          {!editClicked ? (
            <Row className="form-row pb-10">
              <Col className="col-sm-5">
                <AutoCompleteField
                  style={{
                    background: "#F3F6F9",
                    height: "55px",
                    border: "none",
                  }}
                  classNamePrefix="react-select"
                  options={ledgerAccounts}
                  placeholder="Ledger Account"
                  onChange={(value) => {
                    setValue(value);
                  }}
                  defaultValue={defaultValue}
                />
              </Col>
            </Row>
          ) : (
            ""
          )}

          <Row className="form-row pb-10">
            <Col className="col-sm-5">
              <InputField
                {...{
                  formik,
                  title: "Subcategory Name",
                  name: "sub_cat_name",
                  placeholder: "Membership payment",
                  checkValidation: true,
                }}
              />
            </Col>
            <Col className="col-sm-5">
              <InputField
                {...{
                  formik,
                  title: "Year",
                  name: "year",
                  placeholder: "2021",
                  checkValidation: true,
                }}
              />
            </Col>
          </Row>
        </form>
      </div>
      <div className="add-button">
        <MyButton
          content={editClicked ? "Save" : "Add"}
          style={{ width: "150px" }}
          onClick={() => {
            formik.handleSubmit();
          }}
        />
      </div>
    </dv>
  );
};
